import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { CheckCircle2, AlertTriangle, Info, X, AlertCircle } from 'lucide-react';
import '../../styles/erp-theme.css';

const LISTENERS = new Set();
let nextId = 1;

function emit(type, message, opts = {}) {
  const t = { id: nextId++, type, message, duration: opts.duration ?? 3500 };
  LISTENERS.forEach(fn => fn(t));
  return t.id;
}

export const erpToast = {
  success: (m, o) => emit('success', m, o),
  error:   (m, o) => emit('error',   m, o),
  warning: (m, o) => emit('warning', m, o),
  info:    (m, o) => emit('info',    m, o),
};

const ICON = { success: CheckCircle2, error: AlertCircle, warning: AlertTriangle, info: Info };
const COLOR = { success: '#16a34a', error: '#dc2626', warning: '#d97706', info: '#3b82f6' };

export function ERPToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handler = (t) => {
      setToasts(prev => [...prev, t]);
      setTimeout(() => setToasts(prev => prev.filter(x => x.id !== t.id)), t.duration);
    };
    LISTENERS.add(handler);
    return () => LISTENERS.delete(handler);
  }, []);

  const close = useCallback((id) => setToasts(prev => prev.filter(t => t.id !== id)), []);

  if (typeof document === 'undefined') return null;

  return createPortal(
    <div className="erp-toast-container" data-testid="erp-toast-container">
      {toasts.map(t => {
        const Icon = ICON[t.type] || Info;
        return (
          <div key={t.id} className={`erp-toast ${t.type}`} data-testid={`erp-toast-${t.type}`}>
            <Icon size={16} color={COLOR[t.type]} style={{ flexShrink: 0, marginTop: 1 }} />
            <div style={{ flex: 1 }}>{t.message}</div>
            <button className="erp-toast-close" onClick={() => close(t.id)}><X size={12} /></button>
          </div>
        );
      })}
    </div>,
    document.body
  );
}

export default ERPToastContainer;
